import axios from "axios";
import toast from "react-hot-toast";

const api = axios.create({
  baseURL: "https://service.adwave.in/api/p",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImJodW1pa2FAZG90aXguaW8iLCJleHAiOjE3NzEwOTA1MDQsImlhdCI6MTc3MTAwNDEwNCwiaWQiOiIxMTc5OTJkYy00Yjk4LTRjNDQtYmE5Yy1lYTAyMzE1ZmExMzgiLCJuYW1lIjoiQmh1bWlrYSIsInJvbGUiOiJhZG1pbiJ9.pZc66-7jCbLpYmfL_MhTG1YEz6AXO3B0kYf_399DNBA.BhjEpvMS5wtTXqJyG1NilrQusWikArO3UhbasEaz8Rg";

  config.headers.Authorization = `Bearer ${token}`;
  //add app this token
  const appToken = localStorage.getItem("appToken");
  if (appToken) {
    config.headers["x-app-token"] = appToken;
  }

  return config;
});

/* 🔥 GLOBAL RESPONSE HANDLER */
api.interceptors.response.use(
  (response) => {
    // ✅ API returned 200 but logical error

    if (response.data?.success === false) {
      window.location.replace("/error"); // or "/500"
      return Promise.reject(response);
    }

    return response;
  },
  (error) => {
    // ❌ HTTP error (500, 401, etc.)
    // if (error.response?.data?.success === false) {
    //   window.location.replace("/error");
    // }
    // console.error("API Error:", error.response || error.message || error);
    if (error.response.status === 400) {
      toast.error(error.response.data?.error || "already exist");
    }
    if (error.response.status === 401) {
      toast.error(
        error.response.data?.error || "Session expired. Please login again.",
      );
      // Clear invalid token
      localStorage.removeItem("token");
      localStorage.removeItem("appToken");
      // Redirect to login page
      window.location.href = "/login";
    }
     if (error.response.status === 403) {
      toast.error(error.response.data?.error || "You are blocked");
    }
    if (error.response.status === 409) {
      toast.error(error.response.data?.error || "Conflict error occurred.");
    } 
     if (error.response.status === 413) {
      toast.error(error.response.data?.error || "entity too large.");
    } 
     if (error.response.status === 500) {
      toast.error(error.response.data?.error || "internal server error.");
    } 
     if (error.response.status === 502) {
      toast.error(error.response.data?.error || "bad request.");
       localStorage.removeItem("appToken");
      // Redirect to login page
      window.location.href = "/apps";
    } 

    return Promise.reject(error);
  },
);

export default api;
